import CancelSubscriptionModal from './modals/cancelSubscriptionModal';
import CancelSubscriptionFeedbackModal from './modals/cancelSubscriptionFeedbackModal';
import CancelSubscriptionConfirmationModal from './modals/cancelSubscriptionConfirmationModal';
import InvoicesModal from './modals/invoicesModal';
import InvoiceDetailsModal from './modals/invoiceDetailsModal';
import ConfirmationModal from './modals/confirmationModal';
/* PLOP_INJECT_MODAL_IMPORT */

import {
    CANCEL_SUBSCRIPTION,
    CANCEL_SUBSCRIPTION_CONFIRMATION,
    CANCEL_SUBSCRIPTION_FEEDBACK,
    INVOICE_DETAILS,
    INVOICES,
    CONFIRMATION_MODAL,
    /* PLOP_INJECT_MODAL_TYPE_IMPORT */
} from './types';

export default {
    [CANCEL_SUBSCRIPTION]: CancelSubscriptionModal,
    [CANCEL_SUBSCRIPTION_FEEDBACK]: CancelSubscriptionFeedbackModal,
    [CANCEL_SUBSCRIPTION_CONFIRMATION]: CancelSubscriptionConfirmationModal,
    [INVOICES]: InvoicesModal,
    [INVOICE_DETAILS]: InvoiceDetailsModal,
    [CONFIRMATION_MODAL]: ConfirmationModal,
    /* PLOP_INJECT_MODAL_EXPORT */
};
